import { REQUEST_BCBS_CARRIERS_SUCCEEDED } from './bcbsCarriersActions';

const InitialState = [];

export default function bcbsCarriersReducer(state = InitialState, action) {
    const { type, payload } = action;

    switch (type) {
        case REQUEST_BCBS_CARRIERS_SUCCEEDED:
            return payload.carriers.map(carrier => ({
                id: carrier[0],
                name: carrier[1],
            }));

        default:
            return state;
    }
}
